export function parseHlsResponse(text: string): Array<{
  bitrate: number;
  width: number;
  height: number;
}> {
  let arr = text
    .split('\n')
    .filter(item => item.includes('BANDWIDTH') && item.includes('RESOLUTION'))
    .map(element => element.slice(element.indexOf(':') + 1));
  let data: Array<{
    bitrate: number;
    width: number;
    height: number;
  }> = [];
  arr.map(value => {
    let items = value.split(',');
    let result: {
      bitrate?: number;
      width?: number;
      height?: number;
    } = {};
    items.forEach(item => {
      let t = item.split('=');
      if (t[0].toUpperCase() === 'BANDWIDTH') {
        result['bitrate'] = Number(t[1]);
      } else if (t[0].toUpperCase() === 'RESOLUTION') {
        let res = t[1].split('x');
        result['width'] = Number(res[0]);
        result['height'] = Number(res[1]);
      }
    });
    if (result.bitrate && result.width && result.height) {
      data.push(
        result as {
          bitrate: number;
          width: number;
          height: number;
        },
      );
    }
  });
  return data;
}